<div class="layout-content">
   <form (ngSubmit)="submit()" [formGroup]="sectionForm">
      <div class="grid mt-4">
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="KeyHelp" autocomplete="KeyHelp" placeholder="{{ 'KEY_SECTION' | translate }}" maxlength="50" />
               <label for="float-input">{{ 'KEY_SECTION' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleIt" autocomplete="TitleIt" placeholder="{{ 'ITALIANO' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'ITALIANO' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleEn" autocomplete="TitleEn" placeholder="{{ 'INGLESE' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'INGLESE' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleEs" autocomplete="TitleEs" placeholder="{{ 'SPAGNOLO' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'SPAGNOLO' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleDe" autocomplete="TitleDe" placeholder="{{ 'TEDESCO' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'TEDESCO' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleFr" autocomplete="TitleFr" placeholder="{{ 'FRANCESE' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'FRANCESE' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleNl" autocomplete="TitleNl" placeholder="{{ 'OLANDESE' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'OLANDESE' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitlePl" autocomplete="TitlePl" placeholder="{{ 'POLACCO' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'POLACCO' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleRu" autocomplete="TitleRu" placeholder="{{ 'RUSSO' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'RUSSO' | translate }}*</label>
            </span>
         </div>
         <div class="col-12 flex justify-content-center">
            <span class="p-float-label w-full">
               <input type="text" pInputText class="w-full" formControlName="TitleSk" autocomplete="TitleSk" placeholder="{{ 'SLOVENO' | translate }}" maxlength="100" />
               <label for="float-input">{{ 'SLOVENO' | translate }}*</label>
            </span>
         </div>
      </div>

      <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
         <button type="submit" pButton pRipple [disabled]="!sectionForm.valid" label="{{ 'CONFIRM' | translate }}" class="p-button-primary text-xl font-normal mt-3 sm:mt-0 mr-0 sm:mr-1" [ngClass]="dynamicButtonWidth()">
         </button>
         <button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}" class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
         </button>
      </div>
   </form>
</div>
